import styled from 'styled-components';

export const ThirdPartyModalComponent = styled.section`
  /* Use correct HTML element! */
`;
